// SCAFFOLDED BY g8 — edit directly or run `g8 create --regen` to regenerate.
import React from "react";
import { SectionRenderer, registerServiceSections } from "@repo/features/site";
import { useClientConfig } from "@repo/backend/providers";

registerServiceSections();

// Section layout is hardcoded at scaffold time — edit here or regenerate.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SECTIONS: any[] = [
  {
    "id": "hero-0",
    "type": "hero",
    "variant": "hero-full-bleed",
    "props": {
      "headlineLogoUrl": "/andersons-opt1-C-v1-transparent.svg",
      "headlineLogoAlt": "Anderson's Total Lawn Care",
      "headline": "",
      "accentPhrase": "",
      "subheadline": "Lima's most reliable lawn care service.",
      "ctaPrimaryLabel": "Get Free Estimate",
      "ctaPrimaryTarget": "#quote",
      "ctaSecondaryLabel": "Our Services",
      "ctaSecondaryTarget": "#services",
      "imageUrl": "https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=1920&auto=format&fit=crop",
      "contentAlign": "center"
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "story-0",
    "type": "story",
    "variant": "story-stat",
    "props": {
      "eyebrow": "Lima Grown. Owner Operated.",
      "headline": "Owner-Led Operations.",
      "body": [
        "Anderson's has served Lima, Ohio since 2018 with the owner present at every job. We never subcontract work and maintain the same crew for each property.",
        "Consistent results you can count on all season long. Your yard is our reputation — we defend it aggressively."
      ],
      "stat": "7+",
      "statLabel": "Years of Service",
      "badgeLabel": "Lima Standard Certified",
      "badgeSubLabel": "Full Liability & Performance Insured"
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "services-0",
    "type": "services",
    "variant": "services-numbered",
    "props": {
      "headline": "Service Portfolio",
      "subheadline": "Complete lawn care solutions engineered for Lima homeowners who demand consistent results.",
      "services": [
        {
          "name": "Precision Mowing",
          "description": "Weekly cuts with edging, blowout, and same-crew consistency all season long.",
          "eyebrow": "Maintenance",
          "priceLabel": "From $35/visit"
        },
        {
          "name": "Spring Cleanup",
          "description": "Power raking, bed edging, and first fertilization to kickstart the season.",
          "eyebrow": "Seasonal",
          "priceLabel": "From $180"
        },
        {
          "name": "Fall Maintenance",
          "description": "Core aeration, final cut, and soil fortification before winter sets in.",
          "eyebrow": "Seasonal",
          "priceLabel": "From $150"
        },
        {
          "name": "Snow Removal",
          "description": "Rapid deployment — path cleared before the day begins.",
          "eyebrow": "Tactical",
          "priceLabel": "Custom pricing"
        }
      ],
      "ctaLabel": "Inquire Now",
      "ctaTarget": "#quote"
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "gallery-0",
    "type": "gallery",
    "variant": "gallery-masonry",
    "props": {
      "headline": "Our Work",
      "subheadline": "Every job inspected by the owner for quality control.",
      "columns": 3,
      "photos": [
        { "src": "/IMG_1035.jpg",  "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1111.webp", "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1154.jpg",  "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1213.webp", "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1232.webp", "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1234.webp", "alt": "Anderson's lawn care work" },
        { "src": "/IMG_1245.webp", "alt": "Anderson's lawn care work" }
      ]
    },
    "animation": {
      "preset": "stagger-children",
      "stagger": 0.07
    }
  },
  {
    "id": "quote-0",
    "type": "quote",
    "variant": "quote-form",
    "props": {
      "heading": "Free Estimate",
      "description": "Complete our 30-second request form and we'll contact you within 24 hours.",
      "fields": [
        "name",
        "phone",
        "email",
        "address",
        "serviceType",
        "notes"
      ],
      "serviceOptions": [
        { "value": "precision-mowing", "label": "Precision Mowing" },
        { "value": "spring-cleanup", "label": "Spring Cleanup" },
        { "value": "fall-maintenance", "label": "Fall Maintenance" },
        { "value": "snow-removal", "label": "Snow Removal" },
        { "value": "other", "label": "Other / custom" }
      ],
      "submitCallable": "submitQuoteLead"
    },
    "animation": {
      "preset": "reveal-clip"
    }
  },
  {
    "id": "service-area-0",
    "type": "service-area",
    "variant": "service-area-radius",
    "props": {
      "headline": "Serving Lima & Surrounding Areas",
      "subheadline": "We cover Lima and the communities around it. If you're within our zone, we'll be there.",
      "latitude": 40.7382,
      "longitude": -84.1052,
      "radiusMiles": 20,
      "markerLabel": "Anderson's Total Lawn Care",
      "zoom": 8,
      "areasServed": [
        "Lima", "Bluffton", "Ada", "Delphos", "Wapakoneta",
        "St. Marys", "Elida", "Spencerville", "Beaverdam", "Cairo"
      ],
      "servicePolygon": [
        [-84.1052, 41.0281],
        [-83.9808, 40.9658],
        [-83.8479, 40.9330],
        [-83.8048, 40.8324],
        [-83.7991, 40.7382],
        [-83.8578, 40.6606],
        [-83.9292, 40.6051],
        [-84.0028, 40.5508],
        [-84.1052, 40.5063],
        [-84.2367, 40.4972],
        [-84.3625, 40.5434],
        [-84.4056, 40.6440],
        [-84.4304, 40.7382],
        [-84.3214, 40.9021],
        [-84.2367, 40.9792],
        [-84.1052, 41.0281]
      ]
    },
    "animation": {
      "preset": "zoom-out"
    }
  },
  {
    "id": "hours-0",
    "type": "hours",
    "variant": "hours-simple",
    "props": {
      "headline": "Service Hours",
      "description": "We work when you're at work. Evening and weekend appointments available by request.",
      "hours": [
        { "day": "Monday – Friday", "hours": "6:00 AM – 6:00 PM" },
        { "day": "Saturday", "hours": "7:00 AM – 5:00 PM" },
        { "day": "Sunday", "hours": "Closed" }
      ]
    },
    "animation": {
      "preset": "stagger-cascade",
      "stagger": 0.09
    }
  }
];

export function HomePage() {
  const config = useClientConfig();
  return (
    <main>
      <SectionRenderer
        sections={SECTIONS}
        clientId="maxanderson"
        features={config.features}
      />
    </main>
  );
}
